import React, { useState, useRef, useEffect } from "react";
import {
  ListAndImageBase,
  Title,
  Wrapper,
  Image,
  List,
} from "./list-and-image.styled";
import Entry from "./list-entry";
import { ImageAndListSliceFragment } from "../../types/graphql";
import { SliceComponentProps } from "@prismicio/react";
import { Slice } from "@prismicio/types";
import { IPageContext } from "../../types/types";
import { SharedSliceType } from "../shared-slice/shared-slice";

export type IListAndImageProps = Slice<
  SharedSliceType,
  ImageAndListSliceFragment["primary"],
  ImageAndListSliceFragment["items"][number]
> & { type: SharedSliceType };

const ListAndImage = ({
  slice,
  context,
}: SliceComponentProps<IListAndImageProps, IPageContext>) => {
  const title = slice.primary?.title1;
  const list = slice.items;

  const [activeEntry, setActiveEntry] = useState({ id: 0, isOpen: true });

  // Used to calculate the height of list to set max-height on overflowed content
  const listRef = useRef<HTMLDivElement>(null);
  const [listHeight, setListHeight] = useState(0);

  useEffect(() => {
    const height = listRef.current?.offsetHeight;
    height && setListHeight(height);
  }, [listRef]);

  return (
    <ListAndImageBase className="slice-section">
      <div className="container">
        {title && <Title>{title}</Title>}
        {list && (
          <Wrapper>
            {list[activeEntry.id]?.image1 && (
              <Image
                src={list[activeEntry.id]!.image1?.url || ""}
                alt={list[activeEntry.id]!.image1?.alt || "Xometry Image"}
              />
            )}
            <List ref={listRef}>
              {list.map(
                (entry, index) =>
                  entry && (
                    <Entry
                      key={index}
                      header={entry.name}
                      content={entry.description?.richText}
                      entryId={index}
                      activeEntry={activeEntry}
                      setActiveEntry={setActiveEntry}
                      listHeight={listHeight}
                      // Pass image data to entry for display on mobile
                      image={list[index]?.image1}
                    />
                  )
              )}
            </List>
          </Wrapper>
        )}
      </div>
    </ListAndImageBase>
  );
};

export default ListAndImage;
